import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.element.setAttribute('novalidate', '')
    this.boundSubmit = this.handleSubmit.bind(this)
    this.element.addEventListener('submit', this.boundSubmit)

    this.element.querySelectorAll('input, textarea, select').forEach(field => {
      field.addEventListener('change', () => this.validateField(field))
    })
  }

  disconnect() {
    this.element.removeEventListener('submit', this.boundSubmit)
  }

  handleSubmit(event) {
    if (!this.element.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.element.classList.add('was-validated')
  }

  validateField(field) {
    if (field.checkValidity()) {
      field.classList.remove('is-invalid')
      field.classList.add('is-valid')
    } else {
      field.classList.remove('is-valid')
      field.classList.add('is-invalid')
    }
  }
}
